import React, { useContext } from 'react';
import { Button, Container, Card, CardBody, Alert } from "reactstrap";
import Header from '../../Project/Create/Steps/Header';
import { PixelContext } from '../../../context/Pixel';

function UploadPhotoLogin({ onHandleLogin, onHandleHomeownerSignUp, onHandleGoogleLogin }) {

  const { trackAnalyticsEvent, Events } = useContext(PixelContext);

  return (
    <>
      <Header title="Step 1: Upload Photo" progress={12} />
      <Container className="d-flex flex-column justify-content-between" style={{ maxWidth: '450px', minHeight: '80vh' }}>

        <Card className="shadow-sm rounded-4 my-1 flex-grow-1 border">
          <CardBody className="d-flex flex-column align-items-center text-center px-4 py-5">

            <div className="position-relative mb-4">
              <div className="border border-dark rounded-circle d-flex align-items-center justify-content-center" style={{ width: '60px', height: '60px' }}>
                <svg xmlns="http://w3.org" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
              </div>
              <div className="position-absolute bottom-0 end-0 bg-primary text-white rounded-circle p-1 d-flex align-items-center justify-content-center" style={{ width: '24px', height: '24px', transform: 'translate(15%, 10%)' }}>
                <svg xmlns="http://w3.org" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
              </div>
            </div>

            <h3 className="fw-bold mb-1" style={{ fontSize: '1.65rem' }}>Create your account</h3>
            <p className="text-secondary mb-4 fs-5">to unlock your results</p>

            <div className="bg-light rounded-3 p-3 mb-3 text-start w-100 border d-flex align-items-start gap-3">
              <div className="text-primary mt-1 flex-shrink-0">
                <svg xmlns="http://w3.org" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
                  <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                  <path d="m10 13-3 3h10l-4-4-3 1Z" />
                </svg>
              </div>
              <div>
                <p className="fw-semibold mb-1 text-dark" style={{ fontSize: '0.95rem' }}>
                  We're analyzing your photo and generating ideas for your space.
                </p>
                <p className="text-secondary m-0" style={{ fontSize: '0.9rem' }}>
                  Create an account now to save your results and access them anytime, anywhere.
                </p>
              </div>
            </div>

            <Alert className="w-100 text-start d-flex align-items-start gap-2 py-2.5 px-3 border border-warning-subtle rounded-3 mb-4" style={{ backgroundColor: '#FFFDF0' }}>
              <div className="text-warning mt-0.5 flex-shrink-0">
                <svg xmlns="http://w3.org" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" x2="12" y1="8" y2="12" />
                  <line x1="12" x2="12.01" y1="16" y2="16" />
                </svg>
              </div>
              <span className="text-dark" style={{ fontSize: '0.88rem', lineHeight: '1.4' }}>
                <strong>If you don't create an account,</strong> you won't be able to see or recover your results.
              </span>
            </Alert>

            <Button color="primary" className="w-100 py-2.5 mb-2 d-flex align-items-center justify-content-center gap-2 fw-semibold rounded-3" style={{ fontSize: '0.95rem' }}
              onClick={() => {trackAnalyticsEvent(Events.UPLOAD_PHOTO_SIGNUP_EMAIL_CLICK); onHandleHomeownerSignUp()}}>
              <svg xmlns="http://w3.org" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className='mx-0'>
                <rect width="20" height="16" x="2" y="4" rx="2" />
                <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
              </svg>
              Sign up with Email
            </Button>

            <Button outline color="secondary" className="w-100 py-2.5 d-flex align-items-center justify-content-center gap-2 fw-semibold rounded-3 text-dark border-secondary-subtle"
              style={{ fontSize: '0.95rem' }} onClick={() => { trackAnalyticsEvent(Events.UPLOAD_PHOTO_CONTINUE_GOOGLE_CLICK); onHandleGoogleLogin() }}>
              <svg xmlns="http://w3.org" width="18" height="18" viewBox="0 0 24 24" className='mx-0'>
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22.81-.63z" />
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z" />
              </svg>
              Continue with Google
            </Button>

            <div className="w-100 my-4 position-relative text-center d-flex align-items-center">
              <hr className="text-muted flex-grow-1 mb-3" />
              <span className="position-absolute top-50 start-50 translate-middle bg-white px-3 text-muted" style={{ fontSize: '0.85rem' }}>
                Already have an account?
              </span>
              <hr className="text-muted mb-3" />
            </div>

            <Button color="link" className="text-primary fw-bold text-decoration-none mb-2 p-0" style={{ fontSize: '0.95rem' }} 
              onClick={(() => {trackAnalyticsEvent(Events.UPLOAD_PHOTO_LOGIN_CLICK); onHandleLogin()})}>Log in</Button>

          </CardBody>
        </Card>

        <footer className="text-center text-muted w-100 py-2 d-flex align-items-center justify-content-center gap-1.5" style={{ fontSize: '0.82rem' }}>
          <svg xmlns="http://w3.org" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mx-1">
            <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
          Your data is secure and will never be shared.
        </footer>

      </Container>
    </>
  );
}

export default UploadPhotoLogin;
